import { ADD_NOTIFICATION_LOADED, REMOVE_NOTIFICATION_LOADED } from 'store/actions/notifications';
// utils
import { v4 as uuid } from 'uuid';

// init state
const initialState = {
  notifications: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NOTIFICATION_LOADED:
      return { ...state, notifications: { [uuid()]: action.payload, ...state.notifications } };
    case REMOVE_NOTIFICATION_LOADED:
      const {
        [action.payload]: {},
        ...filteredNotifications
      } = state.notifications;
      return {
        ...state,
        notifications: filteredNotifications,
      };
    default:
      return state;
  }
};

export default reducer;
